import axios from 'axios'
import cookie from "./cookie";
import {Message} from 'element-ui'
import router from "@/router/index"


const http = axios.create({

  responseType: "text",//此处由"json"改为"text",以兼容 IE 浏览器
  /*responseType: "json",*/

  withCredentials: true,

  headers: {
    "Content-Type": "application/json;charset=utf-8",
    "Pragma": "no-cache",//解决参数缓存问题
    "Cache-Control": "no-cache",
    "X-XSS-Protection": "0",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
    "X-Content-Type-Options": "nosniff",
    "Content-Security-Policy": "default-src 'self'",
  }
});

http.interceptors.request.use(
  request => {
    //请求加上时间戳，防止缓存生效
    if(request.method == 'post' || request.method == 'get'){
      request.params = {
        ...request.params,
        _t: Date.parse(new Date()) / 1000
      }
    }

    //更新cookies有效期
    let token = cookie.getCookie('token');
    cookie.setCookie("token", token, null, 1800);
    return request
  },

  error => {
    Message({
      showClose: true,
      message: error,
      type: "error"
    })
    return error
  }
);


http.interceptors.response.use(
  response => {
    let data = response.data;
    // console.log(data.code);
    if (data.code!=undefined && data.code != '00000') {
      errorStatusHandler(response, data.code);
      return response;
    }

    return response;
  }, error => {
    //Network Error
    if ('Network Error' == error.message) {
      Message({
        showClose: false,
        message: '网络通信超时',
        type: 'error',
      })
    }
  }
);

function errorStatusHandler(response, status) {
  if (status == '10002') {
    cookie.deleteCookie('token');
    router.push({path: "/login"})
  } else if (!response.data.code && response.config.responseType=='blob'){
    //处理返回文件流时，触发的错误提示
    return
    //授权访问的密码不提示错误
  } else if (status === "10045") {
    return
  } else {
    Message({
      showClose: true,
      message: response.data.message,
      type: "error"
    });
  }
}



export default http



// WEBPACK FOOTER //
// ./src/utils/axios.js